import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import Link from "ds/components/Link";
import Box from "ds/components/Box";

import { ApiKeyGroupMappingStatus, CellComponentProps } from "../types";

type ApiKeyGroupMappingListItemNameCellProps = CellComponentProps;

const ApiKeyGroupMappingListItemNameCell = ({ group }: ApiKeyGroupMappingListItemNameCellProps) => {
  const isMapped = group.status === ApiKeyGroupMappingStatus.MAPPED;
  const groupUrl = `/settings/idp-group/${group.id}`;

  return (
    <Box fullWidth gap="large">
      {isMapped ? (
        <Link size="small" variant="secondary" href={groupUrl}>
          {group.groupName}
        </Link>
      ) : (
        <TextEllipsis tooltip={group.groupName} tooltipWidthMode="maxWidthSm">
          {(props) => (
            <Typography {...props} tag="p" variant="p-body3">
              {group.groupName}
            </Typography>
          )}
        </TextEllipsis>
      )}
    </Box>
  );
};

export default ApiKeyGroupMappingListItemNameCell;
